module.exports = __webpack_public_path__ + "public/img/wjb2x.1799d67d.png";